/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*
document.addEventListener ("DOMContentLoaded", event => {
  let header_element = document.getElementsByClassName ("Header")[0];
  let logo_container = document.getElementsByClassName ("")[0];
  
  document.addEventListener ("scroll", function (){
      let bg_color = window.getComputedStyle(header_element).backgroundColor;
      if (bg_color == "rgb(255, 255, 255)") {
        logo_container.src = "https://cdn.shopify.com/s/files/1/2393/0337/t/25/assets/fillies-logo_original.svg";
      } else {
      	logo_container.src = "https://cdn.shopify.com/s/files/1/2393/0337/t/25/assets/fillies-logo.svg"
      }
  });
});
*/


document.addEventListener('DOMContentLoaded', function() {
  // Get all buttons with class "assisbtn"
  var buttons = document.getElementsByClassName('assisbtn');

  // Add click event listener to each button
  Array.from(buttons).forEach(function(button) {
    button.addEventListener('click', function(event) {
      // Prevent default action
      event.preventDefault();

      // Redirect to Google.com
      window.location.href = 'https://api.whatsapp.com/send/?phone=393809051090&text&type=phone_number&app_absent=0';
    });
  });
});
